import React from 'react';
import { factorTitle, qualitativeLabel } from '../lib/strength';

export default function FactorCard({ factor, value, summary, glow, onClick }) {
  const rated = typeof value === 'number' && value >= 1 && value <= 5;
  return (
    <button
      type="button"
      style={glow ? cardGlowStyle : cardStyle}
      onClick={onClick}
      data-factor={factor}
      data-rated={rated ? 'yes' : 'no'}
      data-glow={glow ? 'on' : undefined}
    >
      <div style={headStyle}>
        <span style={nameStyle}>{factorTitle(factor)}</span>
        <PencilIcon />
      </div>
      <div style={valueRowStyle}>
        {rated ? (
          <>
            <span style={numStyle}>{value}</span>
            <span style={labelStyle}>{qualitativeLabel(factor, value)}</span>
          </>
        ) : (
          <span style={notRatedStyle}>Tap to rate</span>
        )}
      </div>
      <div style={pipsStyle}>
        {[1, 2, 3, 4, 5].map((n) => (
          <span
            key={n}
            style={rated && n <= value ? pipOnStyle : pipOffStyle}
            data-pip={rated && n <= value ? 'on' : 'off'}
            aria-hidden="true"
          />
        ))}
      </div>
      {rated && summary && <p style={descStyle}>{summary}</p>}
    </button>
  );
}

function PencilIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" aria-hidden="true" style={{ flexShrink: 0 }}>
      <path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7" stroke="var(--muted)" strokeWidth="1.6" fill="none" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" stroke="var(--muted)" strokeWidth="1.6" fill="none" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

const cardStyle = {
  width: '100%',
  textAlign: 'left',
  padding: '22px 22px 20px',
  background: 'var(--surface)',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: 'var(--line)',
  borderRadius: '4px',
  cursor: 'pointer',
  transition: 'border-color 0.15s, box-shadow 0.2s',
  fontFamily: 'var(--font)',
  color: 'var(--ink)',
};
// Amber ring on the first input that still needs the user's attention,
// computed in Wizard.jsx via firstIncompleteFor(step, inputs). Each
// step pipes a `glowField` prop down and the matching card lights up.
const cardGlowStyle = {
  ...cardStyle,
  borderColor: 'var(--amber)',
  boxShadow: '0 0 0 4px rgba(245, 158, 11, 0.18)',
};
const headStyle = { display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '10px' };
const nameStyle = { fontSize: '14.5px', fontWeight: 500, color: 'var(--ink)' };
const valueRowStyle = { display: 'flex', alignItems: 'baseline', gap: '12px' };
const numStyle = {
  fontFamily: 'var(--display)',
  fontStyle: 'italic',
  fontSize: '42px',
  fontWeight: 500,
  lineHeight: 1,
  color: 'var(--accent)',
  letterSpacing: '-0.02em',
};
const labelStyle = { fontSize: '13px', color: 'var(--ink2)', fontWeight: 500 };
const notRatedStyle = {
  fontFamily: 'var(--display)',
  fontStyle: 'italic',
  fontSize: '20px',
  color: 'var(--muted)',
  lineHeight: 1,
};
const pipsStyle = { display: 'flex', gap: '4px', marginTop: '12px' };
const pipOnStyle = { width: '28px', height: '6px', borderRadius: '3px', background: 'var(--accent)' };
const pipOffStyle = { width: '28px', height: '6px', borderRadius: '3px', background: 'var(--line-dim)' };
const descStyle = { fontSize: '13px', color: 'var(--ink2)', margin: '12px 0 0', lineHeight: 1.5 };
